import { ExternallyVerifiedHealthInformationProto } from "@noom/noom-contracts/noom_contracts/usermodel/baselined/health/external/externally_verified_health_information";

export type EntitlementType = "diabetes" | "glp1" | "prediabetes";

export const mapHealthInformationToEntitlements = (
  healthInformation: ExternallyVerifiedHealthInformationProto | undefined,
): EntitlementType[] => {
  if (!healthInformation) {
    return [];
  }

  const entitlements: EntitlementType[] = [];

  const { hasGlp1Prescription, diabetesCondition } = healthInformation;

  if (hasGlp1Prescription) {
    entitlements.push("glp1");
  }

  if (diabetesCondition === "TYPE_2_DIABETES") {
    entitlements.push("diabetes");
  } else if (diabetesCondition === "PRE_DIABETIC") {
    entitlements.push("prediabetes");
  }

  return entitlements;
};

export const buildMedicalHistorySavePayload = (
  healthInformation: ExternallyVerifiedHealthInformationProto | undefined,
  selectedEntitlements: EntitlementType[],
): ExternallyVerifiedHealthInformationProto | undefined => {
  if (!healthInformation) {
    return undefined;
  }

  const { diabetesCondition, hasGlp1Prescription } = healthInformation;

  return {
    diabetesCondition:
      selectedEntitlements.includes("diabetes") ||
      selectedEntitlements.includes("prediabetes")
        ? diabetesCondition
        : undefined,
    hasGlp1Prescription: selectedEntitlements.includes("glp1")
      ? hasGlp1Prescription
      : undefined,
  };
};
